import moment from "moment-timezone";
import {DEFAULT_TIMEZONE} from '../constants'

const tokenName = 'timeZone';

export const getTimeZone = () => {
    const data = localStorage.getItem(tokenName);

    if(!data) return DEFAULT_TIMEZONE

    const timeZone = JSON.parse(data)

    return timeZone;
}

export const getTimeZoneFormated = (date=new Date()) => {
    const zone = getTimeZoneValue();

    return moment(date).tz(zone, true).hour(0).minute(0).second(0).format();
}

export const getTimeZoneValue = () => {
    const data = localStorage.getItem(tokenName);

    if(!data) return DEFAULT_TIMEZONE;

    const timeZone = JSON.parse(data)

    return timeZone.value;
}

export const setTimeZone = (token) => {
    return localStorage.setItem(tokenName, JSON.stringify(token, null, 2));
};

export const clearTimeZone = () => {
    localStorage.removeItem(tokenName);
    window.location.reload();

    return false;
};
